<template>
  <span>
    <v-dialog v-model="dialog">
      <v-icon color="info" slot="activator">info</v-icon>
      <v-card>
        <v-card-title>
          <div class="headline">Bounding Box Usage</div>
        </v-card-title>
        <v-card-text>
          To enter a bounding box, you might want to use a service like the one from Klokantech
          <a href="http://boundingbox.klokantech.com/" target="_blank">http://boundingbox.klokantech.com/</a>.
          Select the area, use the drop-down box on the bottom right and select "CSV". Then copy and paste the
          values into the bounding box field.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
  export default {
    name: 'v-bounding-box-usage-instructions',
    data() {
      return {
        dialog: false,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/converter/input/BoundingBoxUsageInstructions.vue